


































import { getRange } from '@/libs/time';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class DashboradChart extends Vue {
  @Prop() title!: string;
  @Prop() list!: any;
  @Prop() span!: number;

  date: any = getRange('week');
  @Watch('date')
  onDateChange() {
    this.$emit('changeDate', this.date);
  }

  toFull(params?: any) {
    let [alertDate_ge, alertDate_le] = this.date;
    this.$router.push({
      path: '/task/full',
      query: { ...params, alertDate_ge, alertDate_le }
    });
  }
}
